export const screenRecorderTour = {
  key: "screenRecorder",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="screenrec-order-root"]',
      content: t("Tour_ScreenRecorder_Root"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="screenrec-order-controls"]',
      content: t("Tour_ScreenRecorder_Controls"),
      placement: "bottom",
    },
    {
      target: '[data-tour="screenrec-order-output"]',
      content: t("Tour_ScreenRecorder_Output"),
      placement: "top",
    },
    {
      target: '[data-tour="screenrec-order-settings"]',
      content: t("Tour_ScreenRecorder_Settings"),
      placement: "top",
    },
  ],
};
